import { render } from "./LicencaOrgaoDiferencasTrechos.vue?vue&type=template&id=6d4df804"
import script from "./LicencaOrgaoDiferencasTrechos.vue?vue&type=script&lang=ts"
export * from "./LicencaOrgaoDiferencasTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script